var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaInfoCircle } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
import depositAssets from '../helpers/depositAssets.json';
export var GetAssetInfo = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'getAssetInfoByAddress',
    description: 'This function returns asset information of a specific asset.',
    supportedContracts: cometList,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    asset: new FctAddress({
                        destination: 'erc20',
                        options: depositAssets
                            .filter(function (token) { return token.chainId === Number(chainId); })
                            .map(function (asset) { return (__assign(__assign({}, asset), { value: asset.address })); }),
                        isPreview: true,
                        icon: FaInfoCircle
                    }),
                },
            },
            output: {
                offset: new FctValue({ innerIndex: 0, isPreview: true }),
                asset: new FctAddress({ innerIndex: 1, isPreview: true }),
                priceFeed: new FctAddress({ innerIndex: 2, isPreview: true }),
                scale: new FctValue({ innerIndex: 3, isPreview: true }),
                borrowCollateralFactor: new FctValue({ innerIndex: 4, isPreview: true }),
                liquidateCollateralFactor: new FctValue({ innerIndex: 5, isPreview: true }),
                liquidationFactor: new FctValue({ innerIndex: 6, isPreview: true }),
                supplyCap: new FctValue({ innerIndex: 7, isPreview: true }),
            },
        });
    },
});
